import _get from 'lodash/get'

export const get_eventteam_promoter_generic_invitation = state =>
  _get(state, 'eventteam.promoterGenericInvitation', null)
export const get_eventteam_invitations = state => _get(state, 'eventteam.invitations', [])
export const get_eventteam_event_members = state => _get(state, 'eventteam.eventMembers', [])
export const get_eventteam_brand_members = state => _get(state, 'eventteam.brandMembers', [])
export const get_eventteam_tour_members = state => _get(state, 'eventteam.tourMembers', [])
